
import { get, post, postChange } from './index'
export const user = params =>{
  return get('/api/admin/list', params)
}

export const department =()=> {
  return get('/api/erp/department')
}
export const departmentEhr =()=> {
  return get('/api/ehr/department')
}
export const brand =()=> {
  return get('/api/erp/brand')
}
export const company =()=> {
  return get('/api/erp/company')
}
export const site =()=> {
  return get('/api/erp/second_site')
}
export const system =()=> {
  return get('/api/admin/system_real')
}
export const editGet =(params)=> {
  return postChange('/api/admin/edit?id='+params.id, params,'get')
}
export const editPost =(params)=> {
  return postChange('/api/admin/edit?id='+params.id, params,'post')
} 
export const role =(params)=> {
  return post('/api/admin/role',params)
}

export const add =(params)=> {
  return post('/api/admin/add',params)
}

export const del =(params)=> {
  return post('/api/admin/del',params)
}
export const switchStatus =(params)=> {
  return post('/api/admin/status_switch',params)
}

export const log =(params)=> {
  return get('/api/admin/log?id='+params.id+"&page="+params.page)
}
export const roleDetail =(params)=> {
  return get('/api/admin/role_desc',params)
}


export const infoGet =(params)=> {
  return get('/api/self/info',params)
}
export const infoEdit =(params)=> {
  return post('/api/self/edit',params)
}

export const syncInfo =(params)=> {
  return post('/api/admin/sync_info',params)
}

export const departmentDetail =(params)=> {
  return get('/api/admin/department_desc',params)
}